import { render, staticRenderFns } from "./CaseEditor.vue?vue&type=template&id=440697b6&scoped=true"
import script from "./CaseEditor.vue?vue&type=script&lang=js"
export * from "./CaseEditor.vue?vue&type=script&lang=js"
import style0 from "./CaseEditor.vue?vue&type=style&index=0&id=440697b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440697b6",
  null
  
)

export default component.exports